import React, { Component } from "react";
import "./App.css";
import { Link } from 'react-scroll';

class InternalLinks extends Component {

    render() {
        return (
            <div>
                <div className="page-link">
                    <Link activeClass={"active"} to={"/"} smooth={true} offset={-200} delay={5}>Main</Link>
                </div>
                {/* <div className="page-link"> */}
                {/* <Link activeClass={"active"} to={"/about"} smooth={true} offset={-150} delay={5}>About</Link> */}
                {/* </div> */}
                <div className="page-link">
                <Link activeClass={"active"} to={"/projects"} smooth={true} offset={-90} delay={5}>Projects</Link>
                </div>
                <div className="page-link">
                <Link activeClass={"active"} to={"/contact"} smooth={true} offset={-150} delay={5}>Contact</Link>
                </div>

            </div>
        );
    };
};

export default InternalLinks;